<template>
  <div class="agrmt_cont">
    <div class="print">
      <div class="top">
        <div class="from">
          <p class="name">
            {{this.delivery_info.senderName}}
            <span v-if="this.delivery_info.senderMobile">(T: {{this.delivery_info.senderMobile}})</span>
          </p>
          <p class="addr">{{this.delivery_info.senderAddress}} {{this.delivery_info.senderAddressDetail}}</p>
        </div>
        <div class="s_info">
          <p class="cont">{{this.note.dong_group}}</p>
        </div>
      </div>
      <div class="bottom">
        <div class="rt">
          <div class="to">
            <p class="addr">{{this.note.receiver_address_road_cleaned}} / {{this.note.receiver_address_cleaned}}</p>
            <p class="addr_r">
              {{this.delivery_info.receiverAddress}}
              <br>
              {{this.delivery_info.receiverAddressDetail}}
            </p>
            <p class="rqust">배달 요청 사항: {{this.note.delivery_additional_info}}</p>
            <p class="info">
              {{this.delivery_info.receiverName}}
              <span v-if="this.delivery_info.receiverMobile">(T: {{this.delivery_info.receiverMobile}})</span>
            </p>
          </div>
          <div class="brcode">
            <barcode v-bind:value="this.note.book_id" width=2 height=40></barcode>
          </div>
        </div>
        <div class="gds_info">
          <div class="info">
            <div class="date">
              <p>접수일시: {{this.delivery_info.receivedDate}}</p>
            </div>
          </div>
          <div class="lst">
            <ul>
              <li><p>의약품</p></li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="btn_area_wb">
      <a role="button" class="btn_sbmt_wb"  @click="print">인쇄하기</a>
      <a role="button" class="btn_sbmt_wb" @click="closeModal">닫기</a>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { nameByConstMixin } from '@/lib/mixins'
  import VueBarcode from 'vue-barcode';

  export default {
    mixins: [nameByConstMixin],
    name: 'waybill',
    props: ['consult_id', 'note'],
    data () {
      return {
        delivery_info: {},
      }
    },
    methods: {
      async getDeliveryInfo(){
        if(!this.note.book_id){
          alert('오류가 발생 하였습니다.');
          return false;
        }else{

        try {
          let params = {
            book_id: this.note.book_id,
          }
          await this.axios({
            method: 'get',
            url: '/consult_note/delivery/tracking',
            params: params,
          }).then((response) => {
            // console.log(response);
            if(!response.data.has_error){ //성공
              this.delivery_info = response.data.resp;
            }else{ //실패
              if(response.data.msg){
                alert(response.data.msg);
              }else{
                alert('오류가 발생 하였습니다.');    
              }
              this.closeModal();
            }
          }).catch((error) => {
            console.log('error!: ', error.message);
            alert('오류가 발생 하였습니다.');
            // return false;
            this.closeModal();
          }).finally(() => {
          
          });
         } catch (error) {
           console.log('error: ', error.message);
            alert('오류가 발생 하였습니다.');
            this.closeModal();
         }
        }
      },
      closeModal() {
        // console.log('closeModal!!');
        this.$emit('closeModal');
      },
      print(){
        const printDiv = document.createElement("DIV");
        document.body.style.display = 'block';
        printDiv.style.display = 'none';
        const _tempHTML = document.getElementsByClassName("print")[0].innerHTML;
        const innerHTMLs = "<div>" + _tempHTML + "</div>";
        const popupWindow = window.open("", "_blank", "width=700,height=800");

        let edgeStyle = "";
        if (/Edg/.test(navigator.userAgent)) {
          edgeStyle = 'html { zoom: 0.85; }';
        }

        popupWindow.document.write(
          "<!DOCTYPE html>"+
          "<html>"+
            "<head>"+
              "<meta name='viewport' content='width=device-width, initial-scale=1'>"+
              "<style id='edge-styles'></style>"+
              "<style type='text/css'>"+
                edgeStyle+
                "@supports (-ms-ime-align:auto) {"+
                "  html {"+
                "    zoom: 0.5;"+
                "  }"+
                "}"+
              "</style>"+
              "<link rel='stylesheet' href='/css/waybill_print.css'>"+ // /public/css/waybill_print.css 경로에 있음 공통으로 관리하기 위해 public 폴더로 뺌
            "</head>"+
            "<body style='margin:0px;'><div class='print'>"+innerHTMLs+"</div></body>"+
          "</html>"
        );
        
        popupWindow.document.close();
        popupWindow.focus();
        //1초후 새 창 프린트
        window.setTimeout(function () {
          popupWindow.print();
          popupWindow.close();
        }, 1000);
      
      },
    },
    computed: {
      ...mapState(['account'])
    },
    async mounted () {
      await this.getDeliveryInfo();
    },
    components: {
      'barcode': VueBarcode,
    }
  }
</script>

<style scoped src="@/assets/css/sub_agreement.css"></style>
<style scoped src="../../../public/css/waybill_print.css"></style>

